import ViewStudents from "../components/Student/ViewStudents";

const StudentsPage: React.FC = () => {
  return <ViewStudents />;
};

export default StudentsPage;
